<template>
    <div class="p-4">
        <h2 class="mb-4">Création d'un rôle</h2>
        
        <div v-if="error.length" @submit="sendForm" class="alert alert-danger" role="alert">
        {{ error }}
        </div>

        <form method="POST" @submit="sendForm">
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="inputEmail4">Titre *</label>
                    <input v-model="title" type="text" class="form-control" id="title" placeholder="Titre du rôle" required>
                </div>
                <div class="form-group col-md-6">
                    <label for="inputPassword4">Membre *</label>
                    <select v-model="user" class="form-control" aria-label="Selectionner un membre">
                        <option v-for="user in users" :key="user" v-bind:value="user.uid">{{ user.cn }}</option>
                    </select>
                </div>
            </div>
            <div class="form-group">
                <label for="exampleInputPassword1">Description *</label>
                <textarea class="form-control" v-model="description" id="description" rows="3"></textarea>
            </div>
            
            <button type="submit" class="btn btn-primary">Créer</button>
        </form>
    </div>
</template>
<script>
import conf from '../../../../config/api.js'

export default {
    data() {
        return {
            conf: conf,
            users: [],
            error: "",
            title: "",
            description: ""
        }
    },
    beforeMount() { // Récupération des utilisateurs
        this.axios.get(`${conf.server}/api/ldap/user/all`) // On fait une requete qui va chercher tous les utilisateurs
        .then(res => {
            this.users = res.data.data
        })
    },
    methods: {
        sendForm: function(event) { // On définit une fonction sendForm()
            event.preventDefault() // On empêche le comportement par défaut du navigateur, c'est à dire de soumettre le formulaire

            this.axios.post(`${conf.server}/api/ldap/group/create`, { // On fait une requête axios en POST vers l'API contenant le formulaire 
                cn: this.title,
                description: this.description,
                memberUid: this.user,
            })
            .then((response) => { // En cas de succès
                this.error =""
                console.log(response)
                window.location.href = `${conf.server}/roles`// On redirige vers la liste des rôles
            })
            .catch((err) => { // En cas d'erreur
                console.log(err.response.data.message) // On affiche le message d'erreur
                 this.error = err.response.data.message
            })
        }
    }

}
</script>